import { createAsyncThunk } from '@reduxjs/toolkit';

import { emailQuote, getQuote } from 'shared/api/apiQuote';
import { selectAssemblyDataForQuote } from 'us_pcb_assembly/store/selectors';

export const doQuote = createAsyncThunk(
  'usAssembly/doQuote',
  async (_args, thunkAPI) => {
    const { variant, parameters, suppliers } = selectAssemblyDataForQuote(thunkAPI.getState());
    const token = document.getElementsByName('authenticity_token')[0].value;
    const data = {};

    suppliers.forEach((s) => {
      data[s] = parameters;
    });

    const promise = getQuote({
      data, token, variant, quoteNumber: parameters.product_quote_number,
    });

    return promise
      .then((res) => res.data)
      .catch((error) => thunkAPI.rejectWithValue({ error: error.message }));
  },
);

export const doEmailQuote = createAsyncThunk(
  'usAssembly/doEmailQuote',
  async (args, thunkAPI) => {
    const token = document.getElementsByName('authenticity_token')[0].value;
    const { data } = args;

    const promise = emailQuote({ data, token });

    return promise
      .then((res) => res.data)
      .catch((error) => thunkAPI.rejectWithValue({ error: error.message }));
  },
);
